'use client';

import { useSegmentTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { TrackingFunction } from '../types';

export const useTableOfContentsAnchorClickedTracking = (props = {}, autoTrack: boolean = false): TrackingFunction => {
  return useSegmentTrack(
    {
      eventName: ANALYTICS_EVENTS.TABLE_OF_CONTENTS_ANCHOR_CLICKED,
      properties: props,
    },
    autoTrack,
  );
};
